(function () {
  var STORAGE_KEY = 'cdr_recently_viewed';
  var MAX_STORED = 12;

  function readStored() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  }

  function writeStored(list) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (e) {
      /* localStorage indisponível (modo privado etc.) - degrada silenciosamente */
    }
  }

  function recordCurrentProduct() {
    var section = document.querySelector('recently-viewed-section');
    var handle = section ? section.dataset.currentHandle : '';
    if (!handle) return;

    var list = readStored().filter(function (entry) {
      return entry.handle !== handle;
    });
    list.unshift({ handle: handle, viewedAt: Date.now() });
    writeStored(list.slice(0, MAX_STORED));
  }

  function formatMoney(cents) {
    var format = window.shopMoneyFormat || '${{amount}}';
    var amount = (cents / 100).toFixed(2);
    var parts = amount.split('.');
    var withThousands = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var formattedAmount = withThousands + '.' + parts[1];
    return format.replace(/\{\{\s*amount\s*\}\}/, formattedAmount);
  }

  if (!customElements.get('recently-viewed-section')) {
    customElements.define(
      'recently-viewed-section',
      class RecentlyViewedSection extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-rv-track]');
          this.limit = parseInt(this.dataset.limit, 10) || 8;
          this.currentHandle = this.dataset.currentHandle;

          this.style.setProperty('--rv-items-desktop', this.dataset.itemsDesktop || 5);
          this.style.setProperty('--rv-items-tablet', this.dataset.itemsTablet || 3);
          this.style.setProperty('--rv-items-mobile', this.dataset.itemsMobile || 1.4);

          this.bindNav();
          this.render();
        }

        bindNav() {
          var track = this.track;
          var prevBtn = this.querySelector('[data-rv-prev]');
          var nextBtn = this.querySelector('[data-rv-next]');
          if (!prevBtn || !nextBtn) return;

          var scrollByCard = function (dir) {
            var card = track.querySelector('.recently-viewed__card');
            if (!card) return;
            var amount = card.getBoundingClientRect().width + 12;
            track.scrollBy({ left: dir * amount, behavior: 'smooth' });
          };

          prevBtn.addEventListener('click', function () {
            scrollByCard(-1);
          });
          nextBtn.addEventListener('click', function () {
            scrollByCard(1);
          });
        }

        render() {
          var handles = readStored()
            .filter(function (entry) {
              return entry.handle && entry.handle !== this.currentHandle;
            }, this)
            .slice(0, this.limit)
            .map(function (entry) {
              return entry.handle;
            });

          if (!handles.length) return;

          var self = this;
          Promise.all(
            handles.map(function (handle) {
              return fetch('/products/' + handle + '.js')
                .then(function (res) {
                  return res.ok ? res.json() : null;
                })
                .catch(function () {
                  return null;
                });
            })
          ).then(function (products) {
            var valid = products.filter(Boolean);
            if (!valid.length) return;

            valid.forEach(function (product) {
              self.track.appendChild(self.buildCard(product));
            });
            self.hidden = false;
          });
        }

        buildCard(product) {
          var variant = product.variants && product.variants[0];
          var price = variant ? variant.price : product.price;
          var comparePrice = variant ? variant.compare_at_price : product.compare_at_price;
          var image = product.featured_image || (product.images && product.images[0]);

          var card = document.createElement('a');
          card.className = 'recently-viewed__card';
          card.href = product.url;

          var onSale = comparePrice && comparePrice > price;
          var discountPct = onSale ? Math.round(((comparePrice - price) / comparePrice) * 100) : 0;

          card.innerHTML =
            '<span class="recently-viewed__media">' +
            (onSale ? '<span class="recently-viewed__badge">-' + discountPct + '%</span>' : '') +
            (image ? '<img src="' + image + '" alt="" loading="lazy" width="300" height="300">' : '') +
            '</span>' +
            '<span class="recently-viewed__title">' + (product.title || '') + '</span>' +
            '<span class="recently-viewed__price">' +
            (onSale ? '<s class="recently-viewed__compare">' + formatMoney(comparePrice) + '</s> ' : '') +
            '<span' + (onSale ? ' class="recently-viewed__sale"' : '') + '>' + formatMoney(price) + '</span>' +
            '</span>';

          return card;
        }
      }
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', recordCurrentProduct);
  } else {
    recordCurrentProduct();
  }
})();
